import { observer } from 'mobx-react-lite';
import {
    FILTER_TYPE,
    filterButton,
    sortingButton,
    VIEWER_MODE,
} from '../../__utils/UiConst';
import { useMainContext } from '../../hooks/useMainContext';
import CustomDropdown from '../Globle/CustomDropdown';
import { Divider } from 'antd';
import RoundedButton from '../Globle/RoundedButton';
import { GridIcon, ListIcon } from '../Globle/Icon';

const ProjectFilter = observer(() => {
    const { uiManager } = useMainContext();

    return (
        <div className="mt-[24px] flex justify-between">
            <div className="flex gap-2">
                {filterButton.map((item) => (
                    <button
                        key={item.value}
                        onClick={() => uiManager.setSelectedFilter(item.value)}
                        className={`filter-btn ${uiManager.selectedFilter === item.value ? 'active-filter-btn' : ''}`}>
                        {item.name}
                        <div>{item.count}</div>
                    </button>
                ))}
            </div>
            <div className="flex gap-[16px] items-center h-[32px]">
                <CustomDropdown
                    options={filterButton}
                    value={uiManager.selectedFilter}
                    onChange={(value) => uiManager.setSelectedFilter(value)}
                    className="w-[100px]"
                    variant="borderless"
                />
                <CustomDropdown
                    options={sortingButton}
                    value={uiManager.selectedSorting}
                    onChange={(value) => uiManager.setSelectedSorting(value)}
                    className="w-[150px]"
                    variant="borderless"
                />
                <Divider
                    className="!my-0  !w-[1px] !min-w-[1px] !m-0 !h-[28px] !border-[#CCCCCC]"
                    variant="vertical"
                />
                <RoundedButton
                    icon={<GridIcon />}
                    onClick={() => {
                        uiManager.setSelectedViewMode(VIEWER_MODE.GRID);
                    }}
                    isActive={uiManager.selectedViewMode === VIEWER_MODE.GRID}
                />
                <RoundedButton
                    icon={<ListIcon />}
                    onClick={() => {
                        uiManager.setSelectedViewMode(VIEWER_MODE.LIST);
                    }}
                    isActive={uiManager.selectedViewMode === VIEWER_MODE.LIST}
                />
            </div>
        </div>
    );
});

export default ProjectFilter;
